

export default function Sample1() {
    return(
        <>
            This website  <strong>doesn't fully</strong> support the mobile layout. You may want to open this website on your desktop or check the old version of this site. Thank you!
        </>
    );
}